import React, { useState } from 'react';
import { db } from '../FirebaseComp/firebase'; // Make sure you have Firebase initialized
import { collection, addDoc } from 'firebase/firestore';

import './eventandnews.css';
import { FaCalendarAlt, FaNewspaper, FaBullhorn, FaArrowRight } from 'react-icons/fa';

// Sample data - replace with actual data from your API or backend
const upcomingEvents = [
  {
    id: 1,
    title: "First International Optometric Conference 2026",
    date: "2026-01-24",
    location: "Colombo, Sri Lanka",
    description: "Join us for the biggest optometry event of the year with international speakers."
  },
  // {
  //   id: 2,
  //   title: "Anual General Meeting",
  //   date: "2025-08-20",
  //   location: "Colombo, Sri Lanka",
  //   description: "."
  // }
];

const latestNews = [
  {
    id: 1,
    title: "New Guidelines for Contact Lens Practitioners",
    date: "2025-10-10",
    excerpt: "The association has published updated guidelines for contact lens fitting and aftercare."
  },
  {
    id: 2,
    title: "The Biggest Eye Health Awaness Program",
    date: "2025-09-28",
    excerpt: "We're proud to announce our new Eye Health Awaness Program in rural areas."
  }
];

const announcements = [
  "Member registration for 2025 now open",
  "Call for research papers - Journal of Ceylon Optometry",
  "Workshop on Pediatric Optometry - Registrations limited"
];

function EventAndNews() {



  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setError('');
    
    // Basic email validation
    if (!email || !email.includes('@')) {
      setError('Please enter a valid email address');
      return;
    }

    setLoading(true);
    
    try {
      // Add email to Firestore
      await addDoc(collection(db, 'subscribelist'), {
        email: email,
        timestamp: new Date(),
      });
      
      setSubscribed(true);
      setEmail('');
    } catch (err) {
      console.error("Error adding document: ", err);
      setError('Failed to subscribe. Please try again.');
    } finally {
      setLoading(false);
    }
  };  




  return (
    <div className="event-news-container">
      <header className="page-header">
        <h1>Events & News</h1>
        <p>Stay updated with the latest happenings at Ceylon Eye Care Optometry Association</p>
      </header>

      <div className="content-grid">
        {/* Upcoming Events Section */}
        <section className="events-section">
          <div className="section-header">
            <FaCalendarAlt className="section-icon" />
            <h2>Upcoming Events</h2>
          </div>
          
          <div className="events-list">
            {upcomingEvents.map(event => (
              <div key={event.id} className="event-card">
                <div className="event-date">
                  <span className="event-day">{new Date(event.date).getDate()}</span>
                  <span className="event-month">{new Date(event.date).toLocaleString('default', { month: 'short' })}</span>
                </div>
                <div className="event-details">
                  <h3>{event.title}</h3>
                  <p className="event-location"><strong>Location:</strong> {event.location}</p>
                  <p>{event.description}</p>
                  <button className="cta-button">
                    Learn More <FaArrowRight />
                  </button>
                </div>
              </div>
            ))}
          </div>
          
          <button className="view-all-button">View All Events</button>
        </section>

        {/* Latest News Section */}
        <section className="news-section">
          <div className="section-header">
            <FaNewspaper className="section-icon" />
            <h2>Latest News</h2>
          </div>
          
          <div className="news-list">
            {latestNews.map(news => (
              <div key={news.id} className="news-card">
                <div className="news-date">
                  {new Date(news.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                </div>
                <h3>{news.title}</h3>
                <p>{news.excerpt}</p>
                <button className="read-more-button">
                  Read More <FaArrowRight />
                </button>
              </div>
            ))}
          </div>
          
          <button className="view-all-button">View All News</button>
        </section>

        {/* Announcements Section */}
        <section className="announcements-section">
          <div className="section-header">
            <FaBullhorn className="section-icon" />
            <h2>Announcements</h2>
          </div>
          
          <ul className="announcements-list">
            {announcements.map((announcement, index) => (
              <li key={index} className="announcement-item">
                {announcement}
              </li>
            ))}
          </ul>

          
          <div className="subscribe-box">
      <h3>Stay Updated</h3>
      <p>Subscribe to our newsletter for regular updates</p>
      
      {subscribed ? (
        <div className="success-message">
          You have subscribed!
        </div>
      ) : (
        <form className="subscribe-form" onSubmit={handleSubscribe}>
          <input
            type="email"
            placeholder="Your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button 
            type="submit" 
            className="subscribe-button"
            disabled={loading}
          >
            {loading ? 'Subscribing...' : 'Subscribe'}
          </button>
          {error && <div className="error-message">{error}</div>}
        </form>
      )}
    </div>


        </section>
      </div>
    </div>
  );
}

export default EventAndNews;